module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<h3 class=\"title\"><a role=\"button\" class=\"switch\" data-toggle=\"collapse\" data-target=\"#custom-behaviors-options\">Behaviors <i class=\"fa pf-carot-down\"></i></a></h3>\r\n<div id=\"custom-behaviors-options\" class=\"collapse in row\">\r\n    <div class=\"col-md-12\" style=\"padding-top:5px;\">\r\n        <input type=\"text\" class=\"new-font-size\" id=\"behaviorCommands\" name=\"behaviorCommands\" value=\"")
    ; __append(escapeFn(behaviorCommands))
    ; __append("\" readonly />\r\n    </div>\r\n    <div class=\"col-md-12\" style=\"padding-top:2px;\">\r\n        <button id=\"editBehavior\" name=\"editBehavior\" class=\"btn btn-default hvr-glow\" style=\"width: 75px;\">Edit</button>\r\n        <button id=\"removeBehavior\" name=\"removeBehavior\" class=\"btn btn-default hvr-glow\"  style=\"width: 100px;\">Remove</button>\r\n    </div>\r\n</div>")
  }
  return __output;

}